import src from "IMAGE";
export default { src, width: 402, height: 122, blurWidth: 0, blurHeight: 0};
